export default __webpack_public_path__ + "static/media/authorbg01.21f5a590.jpg";